<template>
  <Modal
    :title="d['Salary.LeadModal.Title']?.item2"
    v-show="modalOpen"
    :modal-open="modalOpen"
    :has-info-button="false"
    :has-close-button="true"
    @close="handleClose"
  >
    <template v-slot:default>
      <form ref="leadForm">
        <div class="required input-container">
          <div class="flex-row">
            <label for="fname">{{ d['Salary.LeadModal.FirstName']?.item2 }}</label>
            <span class="error-text">{{ d['Salary.LeadModal.Required']?.item2 }}</span>
          </div>
          <input
            type="text"
            id="fname"
            :placeholder="d['Salary.LeadModal.FirstName.Placeholder']?.item2"
          />
        </div>

        <div class="required input-container">
          <div class="flex-row">
            <label for="lname">{{ d['Salary.LeadModal.LastName']?.item2 }}</label>
            <span class="error-text">{{ d['Salary.LeadModal.Required']?.item2 }}</span>
          </div>
          <input
            type="text"
            id="lname"
            :placeholder="d['Salary.LeadModal.LastName.Placeholder']?.item2"
          />
        </div>

        <div class="required input-container">
          <div class="flex-row">
            <label for="private-email">{{ d['Salary.LeadModal.PrivateEmail']?.item2 }}</label>
            <span class="error-text">{{ d['Salary.LeadModal.PrivateEmail.Error']?.item2 }}</span>
          </div>
          <input
            type="email"
            id="private-email"
            :placeholder="d['Salary.LeadModal.PrivateEmail.Placeholder']?.item2"
          />
        </div>

        <div class="input-container">
          <div class="flex-row">
            <label for="country-code">{{ d['Salary.LeadModal.PhoneNumber']?.item2 }}</label>
            <span class="error-text">{{ d['Salary.LeadModal.PhoneNumber.Error']?.item2 }}</span>
          </div>
          <div class="phone-input">
            <div class="required">
              <input
                custom-validation="^\+(\d{1}\-)?(\d{1,3})$"
                id="country-code"
                placeholder="+45"
                value="+45"
                type="search"
                name="not-search"
                autocomplete="off"
              />
            </div>
            <div class="required phone-container">
              <input
                custom-validation="^\d{8,15}$"
                type="tel"
                id="phone-number"
                :placeholder="d['Salary.LeadModal.PhoneNumber.Placeholder']?.item2"
                autocomplete="tel"
              />
            </div>
          </div>
        </div>

        <div class="input-container">
          <div class="flex-row">
            <label for="sector">{{ d['Salary.LeadModal.Sector']?.item2 }}</label>
            <span class="error-text">{{ d['Salary.LeadModal.Required']?.item2 }}</span>
          </div>
          <DropDownRaw :options="sectorList" stateKey="Salary.Questions.Sector" ref="sector" />
        </div>

        <div v-if="dataConsent" class="data-consent" v-html="dataConsent"></div>
      </form>
    </template>
    <template v-slot:actions="{ closeModal }">
      <button class="button secondary" @click="closeModal">
        {{ d['Salary.Navigation.GoBack']?.item2 || 'Tilbage' }}
      </button>
      <button class="button" @click.prevent="handleSubmit">
        {{ d['Salary.Navigation.StartCalculation']?.item2 }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal.vue'
import { state } from '@/lib/state'
import { localDictionary } from '@/lib/state'
import DropDownRaw from '@/components/raw/DropDownRaw.vue'
import { validateFields } from '../../../../services/service-field-validation'

export default {
  name: 'LeadPopup',
  components: {
    Modal,
    DropDownRaw,
  },
  props: {
    modalOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      d: localDictionary(),
      lists: state.lists,
      dataConsent: state.dataConsent?.markup,
    }
  },
  computed: {
    sectorList() {
      return this.lists['sector'] || []
    },
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    handleSubmit() {
      // validate form fields that have required class
      const formContainer = this.$refs.leadForm
      let isValid = validateFields(formContainer)
      const sectorEl = this.$refs.sector?.$el

      // validate sector dropdown
      if (sectorEl && this.$refs.sector.selectedValue === null) {
        isValid = false
        sectorEl.closest('.input-container')?.classList.add('error')
      } else {
        sectorEl.closest('.input-container')?.classList.remove('error')
      }

      if (isValid) {
        // save the lead data to be sent to getSalaryEstimate
        state.leadData = {
          firstname: formContainer.fname.value,
          lastname: formContainer.lname.value,
          email: formContainer['private-email'].value,
          phone: `${formContainer['not-search'].value}${formContainer['phone-number'].value}`,
          lineofbusiness : this.$refs.sector.selectedValue.value,
          //company : "missing frontend value"
        }

        // save email into user object
        state.user.privateEmail = formContainer['private-email'].value

        // start the question flow
        this.emitter.emit('start-questions')
      }
    },
  },
}
</script>

<style scoped lang="postcss">
.phone-input {
  display: flex;
  gap: 10px;

  #country-code {
    max-width: 4ch;

    /* Remove default styling for search inputs */
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &::-webkit-search-decoration,
    &::-webkit-search-cancel-button,
    &::-webkit-search-results-button,
    &::-webkit-search-results-decoration {
      display: none;
    }
  }

  .phone-container {
    flex: auto;
  }
}

.flex-row {
  display: flex;
  gap: 12px;
  align-items: center;

  label {
    flex-shrink: 0;
  }
}

.data-consent {
  margin-top: 32px;
}

.data-consent a {
  background-color: red;
}

.input-container:has(.error) .error-text,
.error .error-text {
  display: block;
}

.error-text {
  font-family: var(--font-it-ex);
  color: var(--color-darkred);
  font-size: 0.875rem;
  display: none;
}
</style>
